<template>
	<div v-if="photos && photos.length > 0"
	     class="b-swiper b-detail__visual b-gallery b-gallery_big">
		<swiper :options="swiperMainOption" ref="swiperMain" class="swiper b-gallery__slider b-gallery__slider_big">
			<swiper-slide v-for="photo in photos" :key="photo.pid" class="b-gallery__slide b-gallery__slide_big">
				<div class="b-gallery__imgWrap b-gallery__imgWrap_big">
					<img itemprop="image" class="b-gallery__img b-gallery__img_big" :src="photo.src"/>
				</div>
			</swiper-slide>
		</swiper>
		<div class="swiper-pagination b-swiper__pagination b-gallery__pagination"></div>
		<div class="b-gallery_small">
			<swiper :options="swiperThumbsOption" ref="swiperThumbs" class="swiper b-gallery__slider b-gallery__slider_small">
				<swiper-slide v-for="photo in photos" :key="'thumbs'+photo.pid" class="b-gallery__slide b-gallery__slide_small">
					<div class="b-gallery__imgWrap b-gallery__imgWrap_small">
						<img class="b-gallery__img b-gallery__img_small" :src="photo.src"/>
					</div>
				</swiper-slide>
			</swiper>
			<div
				class="gallery-thumbs-button-next swiper-button-next b-swiper__btn b-swiper__btn_next b-gallery__btn b-gallery__btn_next">
				<span>
				<svg v-html="IconManager('arrow_right')"></svg>
					</span>
			</div>
			<div
				class="gallery-thumbs-button-prev swiper-button-prev b-swiper__btn b-swiper__btn_prev b-gallery__btn b-gallery__btn_prev">
				<span>
				<svg v-html="IconManager('arrow_right')"></svg>
					</span>
			</div>
		</div>
	</div>
</template>
<script>
import {IconManager} from "citrus.config";

export default {
	name: "CitrusProductSlider",
	props: {
		photos: {
			type: [Array, Object],
			default: () => {
				return [];
			}
		}
	},
	data: function () {
		return {
			swiperMainOption: {
				slidesPerView: 1,
				navigation: {
					nextEl: ".gallery-thumbs-button-next",
					prevEl: ".gallery-thumbs-button-prev"
				},
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
			},
			swiperThumbsOption: {
				watchSlidesProgress: true,
				spaceBetween: 20,
				slidesPerView: 3,
				freeMode: false,
				navigation: {
					nextEl: ".gallery-thumbs-button-next",
					prevEl: ".gallery-thumbs-button-prev"
				},
				breakpoints: {
					870: {
						slidesPerView: 4,
						spaceBetween: 20,
					},
				},
			},
			swiperMain: null,
			swiperThumbs: null,
		}
	},
	mounted() {
		this.$nextTick(() => {
			if (this.$refs.hasOwnProperty("swiperMain")) {
				this.swiperMain = this.$refs.swiperMain.swiper;
			}

			if (this.$refs.hasOwnProperty("swiperThumbs")) {
				this.swiperThumbs = this.$refs.swiperThumbs.swiper;

				/**
				 * Привяжем инициализированный слайдер с превью к основному слайдеру (Переинициализация последнего обязательна)
				 * @type {{swiper: null}}
				 */
				this.swiperMainOption.thumbs = {swiper: this.swiperThumbs};
				this.$refs.swiperMain.swiper.destroy();
				this.$refs.swiperMain.mountInstance();
			}
		});
	},
	methods: {
		IconManager,
	}
};
</script>